import { render, staticRenderFns } from "./recent-servecontent.vue?vue&type=template&id=2d2c4922&"
import script from "./recent-servecontent.vue?vue&type=script&lang=js&"
export * from "./recent-servecontent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports